export default {
  cancel: "Cancel",
  confirm: "Confirm",
  next: "Okay",
  back: "Back to previous Page",
  toClosedOrdersOverview: "To order overview",
};
